export default __webpack_public_path__ + "static/media/hostImgM1.3106191a.jpg";